import { Card } from '@mui/material';
import classNames from 'classnames';
import { Components } from 'react-virtuoso';
import { BaseItem, InternalData } from './VirtualizedTable.types';
import VirtualizedTableNoResults from './noResults/VirtualizedTableNoResults';
import { useStyles } from './virtualizedTable.styles';

export const mobileComponents: Components = {
  EmptyPlaceholder: VirtualizedTableNoResults,
  Item: ({ children, ...props }) => {
    const { classes } = useStyles();

    const item = props.item as InternalData<BaseItem>;

    return (
      <Card
        {...props}
        elevation={0}
        className={classNames({
          [classes.mobileSelectedRow]: item?.isSelected,
          [classes.mobileCard]: true,
        })}
      >
        {children}
      </Card>
    );
  },
};
